<template>
  <p>
    Do you think finding key people has become harder over time? Mainstream sites may be the worst site to find good talent. We recently
    wrote about
    <a @click="$router.push({ path: '/blog/why-linkedin-is-no-longer-a-good-place-to-find-candidates' })">
      how Linkedin could be the worst place to post your job offers
    </a>
  </p>
</template>

<script>
export default {};
</script>

<style></style>
